import { useCallback, useEffect, useState } from "react";
import { Form } from "rsuite";
import { Button } from "../../components/button.component";
import { ModalAddEmail } from "../../components/modal";
import { TextInput } from "../../components/textInput.component";
import { ApiSettings } from "../../core/apis";
import { ISenderEmail } from "../../models/api";
import { useLocation } from "react-router-dom";

export function EmailSettings({ expanded }: { expanded?: boolean }) {
  const location = useLocation();
  const companyId = (() => {
    let id = "";
    if (location.pathname.includes("company")) {
      id = location.pathname.split("/")[2];
    }
    return id;
  })();

  const [showAddEmailModal, setShowAddEmailModal] = useState(false);
  const [apiData, setApiData] = useState<ISenderEmail>();
  const [isLoading, setIsLoading] = useState(false);

  const getData = useCallback(async () => {
    setIsLoading(true);
    const response = await ApiSettings.GetSenderEmail(companyId);
    if (response.isSuccess) {
      setApiData(response.data);
    }
    setIsLoading(false);
  }, [companyId]);

  const toggleModal = () => {
    setShowAddEmailModal((previous) => !previous);
  };

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div className="accordion-item border-0 m-3" id="add-email">
      <p className="accordion-header" id="headingEmail">
        <button
          className="accordion-button p-3 px-4 rounded-pill shadow-none setting-header border border-green-200"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseEmail"
          aria-expanded={expanded}
          aria-controls="collapseEmail"
        >
          Email Settings &nbsp;{" "}
          <small className="small-text">
            (Choose an email address to send email from )
          </small>
        </button>
      </p>
      <div
        id="collapseEmail"
        className={`accordion-collapse collapse ${expanded ? "show" : "hide"}`}
        aria-labelledby="headingEmail"
        data-bs-parent="#collapseEmail"
      >
        <div className="accordion-body border-bottom border-start border-end border-1 rounded setting-box">
          {isLoading ? (
            <div className="p-5 d-flex justify-content-center align-items-center">
              <div className="spinner-border spinner-border-sm" />
            </div>
          ) : apiData?.senderEmail ? (
            <Form className="row" fluid>
              <div className="p-3 border-bottom">
                <div className="row">
                  <TextInput name="Email" disabled value={apiData?.senderEmail}>
                    Email
                  </TextInput>
                </div>
              </div>
              <div className="d-flex justify-content-center space-between">
                <Button
                  className="px-5 mt-3 btn-green"
                  type="button"
                  name="Update Email"
                  onClick={() => setShowAddEmailModal(true)}
                />
              </div>
            </Form>
          ) : (
            <>
              <p className="p-5 text-muted text-center border-bottom">
                No email found
              </p>
              <div className="d-flex justify-content-center space-between">
                <Button
                  className="px-5 mt-3 btn-green"
                  type="button"
                  name="Add Email"
                  onClick={() => setShowAddEmailModal(true)}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <ModalAddEmail
        toggleModal={toggleModal}
        show={showAddEmailModal}
        onSave={getData}
        companyId={companyId}
      />
    </div>
  );
}
